import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormControlName } from '@angular/forms';
import { dateOrEmptyValidator } from '../../shared/validators/date-or-empty.validator';
import { ReportingService, LoadingService } from '../../core/services';
import * as formHelper from '../../shared/helpers/form.helper';
import * as moment from 'moment';
import { BaseComponent } from '../../core/component/base.component';
import { MuLocationEventCounts } from '../../core/services/models';

@Component({
  selector: 'app-location-events',
  templateUrl: './location-events.component.html',
  styleUrls: ['./location-events.component.scss']
})
export class LocationEventsComponent extends BaseComponent implements OnInit {

  events:Array<MuLocationEventCounts> = new Array<MuLocationEventCounts>();
  max:Date = new Date();
  min:Date = new Date('January 1, 1900');

  eventsForm = new FormGroup({
    startDate : new FormControl('',Validators.compose([Validators.required,dateOrEmptyValidator])),
    endDate: new FormControl('',Validators.compose([Validators.required,dateOrEmptyValidator]))  
  });

  constructor(private reportingService:ReportingService, private loadingService:LoadingService) { 
    super();
    const originFormControlNameNgOnChanges = FormControlName.prototype.ngOnChanges;
  
    FormControlName.prototype.ngOnChanges = function () {
      let result;
      if (arguments) {
        result = originFormControlNameNgOnChanges.apply(this, arguments);
      }
      if (this.control && this.valueAccessor && this.valueAccessor.element) {
        this.control.nativeElement = this.valueAccessor.element.nativeElement;
      }
      return result;
    };
  }

  ngOnInit() {
    formHelper.markControlAndChildControlsAsDirty(this.eventsForm);
  }

  wrongOrder():boolean {

    const startDate = new Date(this.eventsForm.get('startDate').value);
    const endDate = new Date(this.eventsForm.get('endDate').value);

    return moment(startDate).isAfter(moment(endDate));

  }

  inRange():boolean {
    
    const startDate = new Date(this.eventsForm.get('startDate').value);
    const endDate = new Date(this.eventsForm.get('endDate').value);

    return moment(startDate).isValid() && moment(startDate).isBetween(this.min,this.max) && moment(endDate).isValid() && moment(endDate).isBetween(this.min,this.max);

  }

  minDate():string {
    return moment(this.min).format("MM[/]DD[/]YYYY");
  }

  maxDate():string {
    return moment(this.max).format("MM[/]DD[/]YYYY");
  }

  startDateValueChanged() {
    this.eventsForm.get('startDate').updateValueAndValidity();
  }

  endDateValueChanged() {
    this.eventsForm.get('endDate').updateValueAndValidity();    
  }

  lookupEvents() {
    
    if(this.eventsForm.valid && !this.wrongOrder() && this.inRange()) {
      this.loadingService.loading = true;
      const startDate: string = new Date(this.eventsForm.get('startDate').value).toDateString();
      const endDateAfter: Date = new Date(this.eventsForm.get('endDate').value);
      endDateAfter.setDate(endDateAfter.getDate() + 1 );
      const endDate: string = endDateAfter.toDateString();
      this.reportingService.getMuLocationDistinctEventCounts(startDate,endDate).subscribe((data:Array<MuLocationEventCounts>) => {
        this.loadingService.loading = false;
        this.events = data;        
      }, error => {
        this.loadingService.loading = false;
        throw(error);
      });
    }
  }

}
